import { Language, TextKeyWithOnlyText } from '../../../pure-js/types/Antiloop.js'
import { getLanguageCode } from '../hooks/useDefaultLanguage.js'
import {
  getFigmaText as getCompactFigmaText,
  getTextStyle as getCompactTextStyle,
  hasCompactText
} from '../../../pure-js/libs/CompactTextRepository.js'
import { getGrooverText } from './GrooverTextRepository.js'

const XXX = 'xxx'
export type Printable = string | number | undefined

export type Options = {
  boldParams?: boolean
  boldParamsIndex?: number
  splitCharacter?: string
}

/**
 * @deprecated Use getGrooverText from GrooverTextRepository instead
 * Enhanced getFigmaText function with backward compatibility
 * Now supports both new compact format (string keys) and legacy TextKeyWithOnlyText format
 */
export const getFigmaText = (textKey: TextKeyWithOnlyText | string, language: Language = getLanguageCode()): string => {
  // Use the new compact text system
  return getCompactFigmaText(textKey, language)
}

/**
 * Get text style from design system or legacy format
 */
export const getTextStyle = (textKey: TextKeyWithOnlyText | string) => {
  return getCompactTextStyle(textKey)
}

/**
 * Check if a text key exists in compact format
 */
export const hasCompactTextKey = (key: string): boolean => {
  return hasCompactText(key)
}

export const getDiscountName = (type: string, customerId?: string) => {
  if (!type) {
    return 'Unknown discount'
  }
  switch (type) {
    case 'student':
      return getGrooverText('componentsPricingControlStudentDiscountRow', undefined, customerId)
    case 'sibling':
      return getGrooverText('registrationStep1SiblingDiscountCheckboxLabel', undefined, customerId)
    case 'senior':
      return getGrooverText('componentsPricingControlSeniorDiscountRow', undefined, customerId)
    case 'couples':
      return getGrooverText('componentsPricingControlCoupleDiscountRow', undefined, customerId)
    case 'multi_course_matrix':
      return getGrooverText('componentsPricingControlBundleDiscountRow', undefined, customerId)
    case 'combined':
      return getGrooverText('componentsPricingControlExtentionDiscountRow', undefined, customerId)
    case 'member':
      return getGrooverText('componentsPricingControlMemberDiscountRow', undefined, customerId)
    case 'early_bird':
      return getGrooverText('componentsPricingControlEarlyBirdDiscountRow', undefined, customerId)
    case 'combo':
      return getGrooverText('componentsPricingControlComboDiscountRow', undefined, customerId)
    case 'continuation':
      return getGrooverText('componentsPricingControlContinuationDiscountRow', undefined, customerId)
    default:
      return 'Unknown discount'
  }
}

export const formatText = (
  text: string,
  params: Printable[],
  { boldParams, boldParamsIndex, splitCharacter = XXX }: Options = {}
): string => {
  const _params = params
    .map((p) => p?.toString() || '')
    .map((p, i) => {
      if (boldParams) return makeBold(p)
      if (boldParamsIndex === i) return makeBold(p)
      return p
    })

  return text
    .split(splitCharacter)
    .reduce((a, b, i) => ({ res: a.res + b + (_params[a.i] || '').toString(), i: i + 1 }), { res: '', i: 0 }).res
}

export function makeBold(p: string): string {
  return `<b>${p}</b>`
}
